import {useState} from 'react'
import axios from 'axios'
import Navbar from './Navbar'

const UnsubscribeEmail = () => {
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState(null)


    const handleSubmit = async (e) => {
        e.preventDefault()
        try {

            const response = await axios.post(`${process.env.REACT_APP_API_URL}/contact/unsubscribe?email=${email}`)
            setMessage(response.data.message)
        } catch (err) {
            setMessage(err.response?.data?.message || "Něco se pokazilo")
        } finally {
            setTimeout(() => {
                setEmail("")
                setMessage(null)
            }, 2000)
        }
    }



  return (
    <div className='min-height'>
        <Navbar />
         <div className="login-container">
            <h2 className="login-title">Odhlášení odběru</h2>
            <form onSubmit={handleSubmit} className='login-form' >
                <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="login-input"
                />
                <button type='submit' className="login-button">Potvrdit</button>
                {message && <p className='message'>{message}</p>}
            </form>
         </div>
    </div>
  )
}

export default UnsubscribeEmail